import script from "./ViewCreatePokemon.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewCreatePokemon.vue?vue&type=script&setup=true&lang=js"

import "./ViewCreatePokemon.vue?vue&type=style&index=0&id=0952dbdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0952dbdd"]])

export default __exports__